export const environment = {
  production: true,
  version: 'a996e86583',
  site_version: 'SITE_VERSION'
};
